/**
 * student/dev — API. The development-only endpoints the dev tools page
 * (features/student/cheats) calls to stage a student's state: XP, badges,
 * endorsements, skill points, a campaign role and accomplishments, and a
 * certificate. The portal shows the page in local and develop alone
 * (isStudentCheatsEnabled), and the backend answers them there alone
 * (DevToolsGuard). The page posted to each through portalFetch by hand,
 * beside the one HTTP client every other screen goes through.
 */
import { http } from '../../_shared/http';

export const studentDevApi = {
  awardXp: (xpAmount: number) => http.post<{ xpPoints: number }>('/student-progress/dev/award-xp', { xpAmount }),
  awardBadge: (achievementId: string) => http.post<{ created: boolean }>('/student-progress/dev/award-badge', { achievementId }),
  removeBadge: (achievementId: string) => http.post<unknown>('/student-progress/dev/remove-badge', { achievementId }),
  adjustEndorsement: (tagId: string, delta: number) =>
    http.post<{ tagId: string; count: number }>('/student-portfolio/dev/adjust-endorsement', { tagId, delta }),
  adjustSkillPoints: (skillId: string, delta: number) =>
    http.post<unknown>('/student-portfolio/dev/adjust-skill-points', { skillId, delta }),
  addAccomplishment: (campaignId: string, text: string) =>
    http.post<unknown>('/student-portfolio/dev/accomplishments', { campaignId, text }),
  deleteAccomplishment: (id: string) => http.del<unknown>(`/student-portfolio/dev/accomplishments/${id}`),
  unlockCertificate: (campaignId: string) => http.post<unknown>('/certificates/dev/unlock', { campaignId }),
  setCampaignRole: (campaignId: string, roleKey?: string, teamSize?: number) =>
    http.post<unknown>('/student-portfolio/dev/set-campaign-role', { campaignId, roleKey, teamSize }),
};
